import gql from 'graphql-tag';

const NETWORK_PROVIDER = gql`
  query Query {
    networkProviderList {
      identifier
      name
    }
  }
`;

export default NETWORK_PROVIDER;
